import { CareerExplorerPeekBody } from './CareerExplorerPeekBody';
import { CareerExplorerPeekEmpty } from './CareerExplorerPeekEmpty';
import type { CareerExplorerPeekProps } from './types';

export const CareerExplorerPeek = ({
  emptyState,
  expandToggle,
  isEmpty = false,
  skills = [],
  skillsHeading,
  statistics = [],
  title,
  trajectory,
}: CareerExplorerPeekProps) => {
  if (isEmpty) {
    return <CareerExplorerPeekEmpty {...emptyState} />;
  }

  return (
    <CareerExplorerPeekBody
      expandToggle={expandToggle}
      skills={skills}
      skillsHeading={skillsHeading}
      statistics={statistics}
      title={title}
      trajectory={trajectory}
    />
  );
};
